"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../base-utils/map-creator");
var table_cell_1 = require("../../../../../core/model/tables/main-structures/table-cell");
var list_1 = require("@devexpress/utils/lib/utils/list");
var bookmark_end_element_destination_1 = require("../../bookmark/bookmark-end-element-destination");
var bookmark_start_element_destination_1 = require("../../bookmark/bookmark-start-element-destination");
var destination_1 = require("../../destination");
var alt_chunk_destination_1 = require("../../document/alt-chunk-destination");
var paragraph_destination_1 = require("../../paragraph/paragraph-destination");
var range_permission_end_element_destination_1 = require("../../range-permission/range-permission-end-element-destination");
var range_permission_start_element_destination_1 = require("../../range-permission/range-permission-start-element-destination");
var deleted_run_content_destination_1 = require("../../runs/deleted-run-content-destination");
var inserted_run_content_destination_1 = require("../../runs/inserted-run-content-destination");
var structured_document_destination_1 = require("../../structured-document-destination");
var table_destination_1 = require("../table/table-destination");
var table_cell_properties_destination_1 = require("./properties/table-cell-properties-destination");
var TableCellDestination = (function (_super) {
    tslib_1.__extends(TableCellDestination, _super);
    function TableCellDestination(data, row) {
        var _this = _super.call(this, data) || this;
        _this.startParagraph = _this.data.subDocumentInfo.paragraphImporter.paragraph;
        _this.cell = new table_cell_1.TableCell(row, _this.data.subDocumentInfo.tableImporter.createDefaultCellProperties());
        _this.paragraphRequired = true;
        return _this;
    }
    Object.defineProperty(TableCellDestination.prototype, "elementHandlerTable", {
        get: function () {
            return TableCellDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    TableCellDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    TableCellDestination.prototype.processElementOpen = function (_reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.cell.startParagraphPosition = this.data.subDocumentInfo.subDocument.positionManager.registerPosition(this.data.subDocumentInfo.paragraphImporter.paragraph.startLogPosition.value);
                this.cell.parentRow.cells.push(this.cell);
                return [2];
            });
        });
    };
    TableCellDestination.prototype.processElementClose = function (_reader) {
        if (this.paragraphRequired) {
            this.endParagraph = this.data.subDocumentInfo.paragraphImporter.paragraph;
            this.data.subDocumentInfo.paragraphImporter.insertParagraph();
        }
        this.cell.endParagrapPosition = this.data.subDocumentInfo.subDocument.positionManager.registerPosition(list_1.ListUtils.last(this.data.subDocumentInfo.subDocument.paragraphs).getEndPosition());
    };
    TableCellDestination.handlerTable = new map_creator_1.MapCreator()
        .add('p', function (data) {
        var destination = TableCellDestination.getThis(data);
        destination.endParagraph = data.subDocumentInfo.paragraphImporter.paragraph;
        destination.paragraphRequired = false;
        return new paragraph_destination_1.ParagraphDestination(data);
    })
        .add('tbl', function (data) {
        var destination = TableCellDestination.getThis(data);
        destination.paragraphRequired = true;
        return new table_destination_1.TableDestination(data, destination.cell);
    })
        .add('tcPr', function (data) { return new table_cell_properties_destination_1.TableCellPropertiesDestination(data, TableCellDestination.getThis(data).cell); })
        .add('bookmarkStart', function (data) { return new bookmark_start_element_destination_1.BookmarkStartElementDestination(data); })
        .add('bookmarkEnd', function (data) { return new bookmark_end_element_destination_1.BookmarkEndElementDestination(data); })
        .add('permStart', function (data) { return new range_permission_start_element_destination_1.RangePermissionStartElementDestination(data); })
        .add('permEnd', function (data) { return new range_permission_end_element_destination_1.RangePermissionEndElementDestination(data); })
        .add('sdt', function (data) { return new structured_document_destination_1.StructuredDocumentDestination(data); })
        .add('customXml', function (data) { return new destination_1.CustomXmlDestination(data); })
        .add('altChunk', function (data) {
        var destination = TableCellDestination.getThis(data);
        destination.endParagraph = data.subDocumentInfo.paragraphImporter.paragraph;
        destination.paragraphRequired = false;
        return new alt_chunk_destination_1.AltChunkDestination(data);
    })
        .add('del', function (data) { return data.options.ignoreDeletedText ? new destination_1.EmptyDestination(data) : new deleted_run_content_destination_1.DeletedRunContentDestination(data); })
        .add('ins', function (data) { return data.options.ignoreInsertedText ? new destination_1.EmptyDestination(data) : new inserted_run_content_destination_1.InsertedRunContentDestination(data); })
        .get();
    return TableCellDestination;
}(destination_1.ElementDestination));
exports.TableCellDestination = TableCellDestination;
